import Script from 'next/script';

type GoogleTagProps = {
  gtmKeyId: string;
};

const isProduction = process.env.APP_ENV === 'production';

export const GoogleTagScript = ({ gtmKeyId = '' }: GoogleTagProps) =>
  isProduction &&
  Boolean(gtmKeyId) && (
    <Script
      id='gtm-script'
      strategy='afterInteractive'
      dangerouslySetInnerHTML={{
        __html: `
          (function(w,d,s,l,i){
              w[l]=w[l]||[];
              w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
              var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
              j.async=true;
              j.src='https://www.googletagmanager.com/gtm.js?id=' + i + dl;
              f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtmKeyId}');
      `
      }}
    />
  );

export const GoogleTagFrame = ({ gtmKeyId = '' }: GoogleTagProps) =>
  isProduction &&
  Boolean(gtmKeyId) && (
    <noscript>
      <iframe
        title='GoogleTagFrame'
        src={`https://www.googletagmanager.com/ns.html?id=${gtmKeyId}`}
        height='0'
        width='0'
        style={{ display: 'none', visibility: 'hidden' }}
      />
    </noscript>
  );
